import { render, staticRenderFns } from "./githubCorner.vue?vue&type=template&id=d7b8c374&scoped=true&"
var script = {}
import style0 from "./githubCorner.vue?vue&type=style&index=0&id=d7b8c374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b8c374",
  null
  
)

export default component.exports